import {sortArrayOfObjects} from "../../../utils/sort";

export function calculateSortedDataKeys(initialRowKeys, rows, sortBy, descending) {

    if ( sortBy === null || sortBy === undefined ) {
        // invalid state so we return sane values to not break anything downstream
        return initialRowKeys
    }

    // we need just the values as an array before we can do any sorting. we add the key to each object
    // in the array for easier restoration of the list of keys later on.
    const rowData = initialRowKeys.map((key) => ({ ...rows[key], key: key }));
    const sortedRowData = sortArrayOfObjects(rowData, sortBy);
    const sortedRowKeys = sortedRowData.map(item => item.key);

    return descending ? sortedRowKeys : sortedRowKeys.reverse();
}
